import { useEffect } from 'react'
import { useOmnichatEnableListener } from './useOmnichatEnableListener'
import { useLCPDetector } from 'utils/hooks/useLCPDetector'

const OMNICHAT_ELEMENT_IDS = [
  'easychat-floating-button',
  'easychat-unread-badge',
  'easychat-close-btn',
  'easychat-chat-dialog',
]

const OmnichatProvider = ({ children }) => {
  const { enabled } = useOmnichatEnableListener()
  const lcpDetected = useLCPDetector()

  const showOmnichatElements = () => {
    OMNICHAT_ELEMENT_IDS.forEach((id) => {
      const el = document.getElementById(id)
      if (el) {
        el.style.display = ''
      }
    })
  }

  const hideOmnichatElements = () => {
    OMNICHAT_ELEMENT_IDS.forEach((id) => {
      const el = document.getElementById(id)
      if (el) el.style.display = 'none'
    })
  }

  useEffect(() => {
    // 若元素已存在則根據 enabled 即時顯示或隱藏
    if (document.getElementById('omnichat-plugin')) {
      if (!enabled) {
        hideOmnichatElements()
      } else {
        showOmnichatElements()
      }
      return
    }

    // 若元素不存在且未啟用則直接 return
    if (!enabled) return
    // 只在 LCP 偵測完成時才載入
    if (!lcpDetected) return

    const initOmnichat = () => {
      if (!document.getElementById('easychat-floating-button')) {
        const a = document.createElement('a')
        a.href = 'javascript:;'
        a.id = 'easychat-floating-button'
        // 固定在距離下方 24px、右側 20px
        a.style.position = 'fixed'
        a.style.bottom = '24px'
        a.style.right = '20px'
        a.style.display = 'none'

        const span = document.createElement('span')
        span.id = 'easychat-unread-badge'
        span.style.display = 'none'

        const d1 = document.createElement('div')
        d1.id = 'easychat-close-btn'
        d1.className = 'easychat-close-btn-close'
        d1.style.display = 'none'

        const d2 = document.createElement('div')
        d2.id = 'easychat-chat-dialog'
        d2.className = 'easychat-chat-dialog-close'
        d2.style.display = 'none'

        const ifrm = document.createElement('iframe')
        ifrm.id = 'easychat-chat-dialog-iframe'
        ifrm.src =
          'https://client-chat.easychat.co/?appkey=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0ZWFtTmFtZSI6ImI0MTdiMmRlLTk4ZjctNDRmYS1hNThjLTQ5MzdhN2JkYTk0NSJ9.hRzln-HfuKQSg2M2liRl3YZB-t6BPGAj7bk4zA0Iz88&lang=zh-Hant'
        ifrm.style.width = '100%'
        ifrm.style.height = '100%'
        ifrm.setAttribute('frameBorder', '0')
        ifrm.setAttribute('scrolling', 'yes')
        d2.appendChild(ifrm)

        document.body.appendChild(a)
        document.body.appendChild(span)
        document.body.appendChild(d1)
        document.body.appendChild(d2)
      }

      // 載入 script 後才顯示按鈕以避免 CLS
      const scriptURL = 'https://chat-plugin.easychat.co/easychat.js'
      if (!document.getElementById('omnichat-plugin')) {
        const scriptTag = document.createElement('script')
        scriptTag.src = scriptURL
        scriptTag.id = 'omnichat-plugin'
        scriptTag.onload = () => {
          showOmnichatElements()
        }
        document.body.appendChild(scriptTag)
      }

      // 按鈕點擊 GA
      const setupButtonListener = () => {
        const container = document.getElementById('easychat-floating-button')
        if (!container || container.dataset.listenerAttached) return

        container.dataset.listenerAttached = 'true'
        container.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'living_action',
            living_event_name: 'line@_click',
          })
        })
      }

      setupButtonListener()
    }

    if (enabled) {
      initOmnichat()
    } else {
      hideOmnichatElements()
    }
  }, [lcpDetected, enabled])

  return <>{children}</>
}

export default OmnichatProvider
